import React, { Fragment } from 'react'
import styles from './GearList.scss'
import { MiniListItem, MiniListItemDetail } from '../../Dashboard/DashboardElements'
import { Distance } from 'common/units'
import { IntroWidget } from 'common/IntroWidget'
import { urls } from 'lib/urls'
import { Msg } from 'lib/localization'
import _ from 'lodash'
import { FormattedMessage as T, defineMessages } from 'react-intl'

const messages = defineMessages({
  addBike: {
    id: 'GearList.addBike',
    defaultMessage: 'Add Bike'
  }
})

export class GearList extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = { showArchived: false }
  }

  showArchived = (e) => {
    e.preventDefault()
    this.setState({ showArchived: true })
  }

  hideArchived = (e) => {
    e.preventDefault()
    this.setState({ showArchived: false })
  }

  render () {
    const { showArchived } = this.state
    const { gear } = this.props

    const visibleGear = showArchived ? gear : gear.filter(x => !x.archived)
    const hasArchived = gear.some(x => x.archived)

    if (gear.length === 0) {
      return (
        <IntroWidget i='md-bicycle' link={<a href='/gear/new'><Msg m={messages.addBike} /></a>}>
          <T id='GearList.intro' defaultMessage='Add a bike to your account to unlock additional features' />
        </IntroWidget>
      )
    }

    return <Fragment>
      {_.sortBy(visibleGear, 'distance').reverse().map(g =>
        <MiniListItem
          href={urls.gear.show(g.id)}
          key={g.id}
          title={g.name}
          left={<img className={styles.gearImg} src={urls.photos.profile(g.highlightedPhotoId)} />}>
          <MiniListItemDetail><Distance short value={g.distance} /></MiniListItemDetail>
        </MiniListItem>
      )}
      {/* This next conditional will ONLY apply if all the user's gear is archived */}
      {visibleGear.length === 0 && <p>
        <T id='GearList.allArchived' defaultMessage="You don't have any unarchived gear. Click below to show all gear." />
      </p>}
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div><a data-card-link href='/gear/new'><Msg m={messages.addBike} /></a></div>
        <div><a data-card-link href='/gear/new?accessory=true'><T id='GearList.addAccessory' defaultMessage='Add Accessory' /></a></div>
        {!showArchived && hasArchived && <div><a data-card-link href='#' onClick={this.showArchived}>
          <T id='GearList.showAll' defaultMessage='Show All' />
        </a></div>}
        {showArchived && hasArchived && <div><a data-card-link href='#' onClick={this.hideArchived}>
          <T id='GearList.hideArchived' defaultMessage='Hide Archived' />
        </a></div>}
      </div>
    </Fragment>
  }
}
